import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	achievementCard: {
		padding: "20px",
		border: `1px solid ${themeColors.colors.success[200]}`,
		borderRadius: "12px",
		backgroundColor: themeColors.colors.success[50],
		height: "100%"
	},
	errorCard: {
		padding: "20px",
		border: `1px solid ${themeColors.colors.error[200]}`,
		borderRadius: "12px",
		backgroundColor: themeColors.colors.error[50],
		height: "100%"
	},
	sentimentBadgeSuccess: {
		width: "48px",
		height: "48px",
		borderRadius: "8px",
		backgroundColor: themeColors.colors.success[600],
		color: themeColors.colors.base.white,
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	sentimentBadgeError: {
		width: "48px",
		height: "48px",
		borderRadius: "8px",
		backgroundColor: themeColors.colors.error[600],
		color: themeColors.colors.base.white,
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	achievementHeading: {
		fontSize: "0.75rem",
		fontWeight: 700,
		color: themeColors.colors.success[700],
		textTransform: "uppercase",
		letterSpacing: "0.05em"
	},
	errorHeading: {
		fontSize: "0.75rem",
		fontWeight: 700,
		color: themeColors.colors.error[700],
		textTransform: "uppercase",
		letterSpacing: "0.05em"
	},
	categoryOutlinedChipSuccess: {
		backgroundColor: "transparent",
		color: themeColors.colors.success[700],
		border: `1px solid ${themeColors.colors.success[600]}`,
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 600,
		height: "24px"
	},
	categoryOutlinedChipError: {
		backgroundColor: "transparent",
		color: themeColors.colors.error[700],
		border: `1px solid ${themeColors.colors.error[600]}`,
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 600,
		height: "24px"
	},
	transcriptQuote: {
		fontSize: "0.875rem",
		fontStyle: "italic",
		fontWeight: 700,
		color: themeColors.colors.system.gray[900]
	}
}))

export default useStyles
